import React, { useContext, useState, useEffect } from "react";
import { ServiceRequestContext } from "context/ServiceRequestContext";
import { INPUT_TYPES } from "utils/CommonConstants";
import TextInput from "sub_components/Common/BloxTextInput";
import styled from "styled-components";
import set from "date-fns/set";
import isAfter from "date-fns/isAfter";
import format from "date-fns/format";
import areIntervalsOverlapping from "date-fns/areIntervalsOverlapping";
import DateTimeClock from "sub_components/Common/DateTimePicker";
import { MicrosoftApi } from "services/microsoft";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import isBefore from "date-fns/isBefore";
import add from "date-fns/add";
import MaskedInput from "react-text-mask";
import {
  CALENDAR_HOURS,
  CALENDAR_END_HOURS,
  TIMEMASK,
} from "utils/Misc/CommonConstants";

function formatEvents(events) {
  try {
    const formattedEvents = [];

    if (!events) {
      return [];
    }

    events.map((element, index) => {
      const startdatetime = new Date(element?.startDateTime?.dateTime);
      const enddatetime = new Date(element?.endDateTime?.dateTime);

      const start = new Date(
        startdatetime.getFullYear(),
        startdatetime.getMonth(),
        startdatetime.getDate(),
        startdatetime.getHours(),
        startdatetime.getMinutes()
      );
      const end = new Date(
        enddatetime.getFullYear(),
        enddatetime.getMonth(),
        enddatetime.getDate(),
        enddatetime.getHours(),
        enddatetime.getMinutes()
      );

      if (element?.status === "BUSY") {
        formattedEvents.push({
          id: index,
          title: "UNAVAILABLE",
          allDay: false,
          start,
          end,
        });
      }
    });

    return formattedEvents;
  } catch (error) {
    console.log(error);
  }
}

const DateTimeStyle = styled.div`
  height: 155px;
  padding-bottom: 10px;
  .blox-text-input {
    width: 100%;
    margin-bottom: 8px;
  }
  .dcblox-date-time-picker-wrapper {
    position: absolute;
  }
  .start-datetime-picker {
    display: flex;
    .date-and-time {
      width: 100%;
      min-height: 10px;
    }
    .timezone-wrapper {
      margin-left: 5px;
      width: 100%;
      .value {
        margin-top: 5px;
      }
    }
  }
  .out-of-hours {
    display: flex;
    padding-top: 10px;
    input {
      cursor: pointer;
    }
  }
  .duration {
    margin-bottom: 8px;
    .duration-times {
      display: flex;
      .duration {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 75px;
        height: 24px;
        border: 1px solid #9164cc;
        margin-right: 10px;
        margin-top: 10px;
        cursor: pointer;
        &.active {
          color: #ffffff;
          background-color: #9164cc;
        }
      }
      .duration:hover {
        box-shadow: 2px 2px 4px 0 ${(props) => props.theme.boxShadow};
      }
    }
  }

  .event-time-picker {
    .hours-wrapper {
      display: flex;
      flex-wrap: wrap;
      input[type="time"]::-webkit-calendar-picker-indicator {
        display: none;
      }
      #appt {
        border: 1px solid #9164cc;
        color: ${(props) => props.theme.defaultFontColor};
        background: ${(props) => props.theme.modalBackground};
        cursor: pointer;
        margin-top: 10px;
      }
      .hour-button,
      .end-hour-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 24px;
        border: 1px solid #9164cc;
        margin-right: 6px;
        margin-top: 8px;
        cursor: pointer;
        .label {
          white-space: nowrap;
        }
        &.selected {
          color: #ffffff;
          background-color: #9164cc;
        }
        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }
      }
      .hour-button:hover {
        box-shadow: 2px 2px 4px 0 ${(props) => props.theme.boxShadow};
      }

      #end-appt {
        border: 1px solid #9164cc;
        color: ${(props) => props.theme.defaultFontColor};
        background: ${(props) => props.theme.modalBackground};
        cursor: pointer;
        margin-top: 10px;
      }
    }
    .info-message {
      margin-top: 10px;
    }
  }

  .ScrollbarsCustom-Track {
    right: -20px !important;
    top: 0px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) => props.theme.support} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 225px;
    .blox-text-input {
      width: 100%;
      margin-bottom: 15px;
    }
    .duration {
      margin-bottom: 15px;
      .duration-times {
        .duration {
          width: 75px;
          height: 24px;
          margin-right: 10px;
          margin-top: 10px;
        }
      }
    }
    .event-time-picker {
      margin-bottom: 15px;
      .hours-wrapper {
        display: flex;
        .hour-button,
        .end-hour-button {
          width: 75px;
          height: 24px;
          margin-right: 10px;
          margin-top: 10px;
        }
      }
    }

    .ScrollbarsCustom-Track {
      right: -10px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 8px !important;
    }

    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 8px !important;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 390px;
    .blox-text-input {
      margin-bottom: 50px;
    }
    .duration {
      margin-bottom: 40px;
      .duration-times {
        .duration {
          width: 150px;
          height: 35px;
          margin-right: 20px;
          margin-top: 20px;
        }
      }
    }
    .ScrollbarsCustom-Track {
      right: -10px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 10px !important;
    }

    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 10px !important;
    }
    .event-time-picker {
      margin-bottom: 50px;
      .hours-wrapper {
        .hour-button,
        .end-hour-button {
          width: 150px;
          height: 35px;
          margin-right: 20px;
          margin-top: 20px;
        }
      }
    }
  }
`;

export const DateTimeSelectionScreen = ({ breakpoint, setShowInfoModal }) => {
  const startDate = new Date();
  const { inputs, change } = useContext(ServiceRequestContext);
  const [showModal, setShowModal] = useState(false);
  const [selectedDay, setSelectedDay] = useState(add(startDate, { days: 1 }));
  const [events, setEvents] = useState(null);
  const [outHours, setOutHours] = useState(false);
  const [outHoursEndTime, setOutEndHours] = useState(false);
  const [loading, setLoading] = useState(true);
  const overlaps = [];

  useEffect(() => {
    const datacenter = inputs?.location;
    const date = new Date(selectedDay);

    if (inputs?.type === "ila") {
      setOutHours(true);
    }

    const params = {
      datacenter,
      startDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: 9,
        minute: 0,
      },
      endDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: 17,
        minute: 0,
      },
    };
    setLoading(true);
    MicrosoftApi.getCalendarView(params)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;

        if (validResponse) {
          const formatedEvents = formatEvents(response.data?.events);

          setEvents(formatedEvents);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
    if (inputs.startDateTime) {
      const selectedHour = document.querySelector(`.end-hour-button.selected`);

      if (selectedHour) {
        selectedHour.classList.remove("selected");
      }
      change({ target: { name: "timeSelected", value: false } });
    }
  }, [selectedDay]);

  function setNewStartDate(value) {
    setSelectedDay(value);
    change({ target: { name: "startDateTime", value: value?.from } });
    if (value?.to) {
      change({ target: { name: "endDateTime", value: value?.to } });
    } else {
      change({ target: { name: "endDateTime", value: value?.from } });
    }
  }

  function setNewStartTime(newTime) {
    const time = format(new Date(newTime), "hh:mm");

    const hours = time.getHours();
    const minutes = time.getMinutes();

    const value = set(new Date(inputs?.startDateTime), { hours, minutes });
    const datetimeend = value.add(inputs?.duration?.value, "m");

    change({ target: { name: "startDateTime", value } });
    change({ target: { name: "endDateTime", value: datetimeend } });
    setShowModal(false);
  }

  function onTimeSelect(selected, index) {
    const selectedHour = document.querySelector(`.hour-button.selected`);
    const newSelectedHour = document.getElementById(`hour-button-${index}`);
    if (selectedHour) {
      selectedHour.classList.remove("selected");
    }
    if (newSelectedHour) {
      newSelectedHour.classList.add("selected");
    }
    const hours = Math.floor(selected?.value);
    const minutes = selected?.value % 1 === 0.5 ? 30 : 0;
    const start = set(new Date(inputs?.startDateTime), {
      hours,
      minutes,
    });

    change({ target: { name: "startDateTime", value: start } });
  }

  function onEndTimeSelect(selected, index) {
    const selectedHour = document.querySelector(`.end-hour-button.selected`);
    const newSelectedHour = document.getElementById(`end-hour-button-${index}`);
    if (selectedHour) {
      selectedHour.classList.remove("selected");
    }
    if (newSelectedHour) {
      newSelectedHour.classList.add("selected");
    }
    const hours = Math.floor(selected?.value);
    const minutes = selected?.value % 1 === 0.5 ? 30 : 0;

    const end = set(new Date(inputs?.endDateTime), {
      hours,
      minutes,
    });

    const within24Hours = add(new Date(), { hours: 24 });

    if (isBefore(inputs.startDateTime, within24Hours)) {
      setShowInfoModal(true);
    }
    change({ target: { name: "endDateTime", value: end } });
    change({ target: { name: "timeSelected", value: true } });
  }

  function checkRange(events, hour) {
    const start = set(new Date(inputs?.startDateTime), { hours: hour?.value });

    const end = new Date(inputs?.endDateTime);
    const endOfDay = set(end, { hours: 17 });

    if (!events || events.length === 0) {
      if (isAfter(end, endOfDay)) {
        return false;
      } else {
        return true;
      }
    }

    const overlaps = [];

    events.map((event) => {
      if (
        isAfter(end, endOfDay) ||
        areIntervalsOverlapping(
          { start, end },
          { start: new Date(event?.start), end: new Date(event?.end) }
        )
      ) {
        overlaps.push(true);
      }
    });

    if (overlaps.length !== 0) {
      return false;
    } else {
      return true;
    }
  }

  function getTimezone(location) {
    let timezone = "";
    if (
      location === "CHA" ||
      location === "ATL" ||
      location === "GSP" ||
      location === "MYR"
    ) {
      timezone = "Eastern Standard Time";
    } else if (location === "HSV" || location === "BHM") {
      timezone = "Central Standard Time";
    } else {
      timezone = "Eastern Standard Time";
    }
    return timezone;
  }

  function setOutHoursTime(event) {
    const time = event?.target.value;

    const timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/;

    if (!timeFormat.test(time)) {
      return; // Exit the function if the input is invalid
    }

    const splitTime = time.split(":");
    const hours = splitTime[0];
    const minutes = splitTime[1];

    const start = set(new Date(inputs?.startDateTime), { hours, minutes });
    change({ target: { name: "startDateTime", value: start } });
  }

  function setOutHoursTimeEnd(event) {
    const time = event?.target.value;

    const timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/;

    if (!timeFormat.test(time)) {
      return; // Exit the function if the input is invalid
    }

    const splitTime = time.split(":");
    const hours = splitTime[0];
    const minutes = splitTime[1];

    const end = set(new Date(inputs?.endDateTime), { hours, minutes });
    const within24Hours = add(new Date(), { hours: 24 });
    if (isBefore(inputs.startDateTime, within24Hours)) {
      setShowInfoModal(true);
    }
    change({ target: { name: "endDateTime", value: end } });
    change({ target: { name: "timeSelected", value: true } });
  }

  function setOutOfHours() {
    const checkBox = document.getElementById("outHoursCheck");
    if (checkBox?.checked === true) {
      setOutHours(true);
    } else {
      setOutHours(false);
    }
  }

  function setValue() {
    if (!inputs?.startDateTime || isNaN(new Date(inputs?.startDateTime))) {
      return "";
    }

    const startDate = new Date(inputs?.startDateTime);

    // If no end date exists or is invalid, just return formatted start date
    if (!inputs?.endDateTime || isNaN(new Date(inputs?.endDateTime))) {
      return format(startDate, "MMMM do yyyy");
    }

    const endDate = new Date(inputs?.endDateTime);

    // Check if dates are the same day
    const isSameDay =
      startDate.getDate() === endDate.getDate() &&
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getFullYear() === endDate.getFullYear();

    if (isSameDay) {
      return format(startDate, "MMMM do yyyy");
    } else {
      // If month and year are the same
      if (
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getFullYear() === endDate.getFullYear()
      ) {
        return format(startDate, "MMMM d") + "-" + format(endDate, "d yyyy");
      }
      // If only year is the same
      else if (startDate.getFullYear() === endDate.getFullYear()) {
        return (
          format(startDate, "MMMM d") + "-" + format(endDate, "MMMM d yyyy")
        );
      }
      // If everything is different
      else {
        return (
          format(startDate, "MMMM d yyyy") +
          "-" +
          format(endDate, "MMMM d yyyy")
        );
      }
    }
  }

  function setOutOfHoursCheckBox() {
    const checkBox = document.getElementById("outHoursCheckEndTime");
    if (checkBox?.checked === true) {
      setOutEndHours(true);
    } else {
      setOutEndHours(false);
    }
  }

  return (
    <DateTimeStyle>
      <ScrollView>
        <div className="start-datetime-picker">
          <div className="date-and-time">
            <TextInput
              placeholder=""
              type={INPUT_TYPES.INPUT}
              label="Choose a start & end date"
              name="start-date-time"
              value={setValue()}
              onClick={setShowModal}
              active={true}
              onChange={() => {}}
              hideCheckmark
            />
            {showModal && (
              <DateTimeClock
                show={showModal}
                displayDate={format(
                  new Date(inputs?.startDateTime),
                  "MMMM do yyyy"
                )}
                callback={setNewStartDate}
                time={format(new Date(inputs?.startDateTime), "h:mm")}
                finishedCallback={setNewStartTime}
                breakpoint={breakpoint}
                inputs={inputs}
                closeModal={() => setShowModal(false)}
              />
            )}
          </div>
          <div className="timezone-wrapper">
            <div className="label labels22">Time Zone:</div>
            <div className="value body10">{getTimezone(inputs.location)}</div>
          </div>
        </div>
        <div className="event-time-picker">
          <div className="labels22">
            {outHours
              ? "Input the requested start time"
              : "Select a start time"}
          </div>
          <div className="hours-wrapper">
            {!loading &&
              !outHours &&
              CALENDAR_HOURS.map((hour, index) => {
                const checkRangeOverlap = checkRange(events, hour);
                if (!checkRangeOverlap) {
                  overlaps.push(true);
                }
                return (
                  <div
                    className={
                      !checkRangeOverlap
                        ? `hour-button disabled`
                        : "hour-button"
                    }
                    id={`hour-button-${index}`}
                    data-cy={`hour-button-${index}`}
                    onClick={() => onTimeSelect(hour, index)}
                  >
                    <div className="label body10">{hour?.label}</div>
                  </div>
                );
              })}
            {outHours && (
              <div className="body10">
                <MaskedInput
                  id="appt"
                  name="appt"
                  mask={TIMEMASK}
                  onChange={setOutHoursTime}
                />
              </div>
            )}
            {loading && !outHours && (
              <div className="loading body10">
                Loading available time slots...
              </div>
            )}
          </div>
          {inputs?.type !== "ila" && (
            <div className="out-of-hours">
              <div className="body10">After hours ? (5PM to 8AM)</div>
              <input
                type="checkbox"
                id="outHoursCheck"
                onClick={setOutOfHours}
              />
            </div>
          )}
          {overlaps.length === 8 && (
            <div className="info-message labels22">
              The desired data center is not accepting guests on this day, or at
              certain times, due to maintenance or unavailable staff. Please
              select a different day , or contact support for additional help.
            </div>
          )}
        </div>
        <div className="event-time-picker">
          <div className="labels22">
            {outHoursEndTime
              ? "Input the requested end time"
              : "Select an end time"}
          </div>
          <div className="hours-wrapper">
            {!outHoursEndTime &&
              CALENDAR_END_HOURS.map((hour, index) => {
                return (
                  <div
                    className={"end-hour-button"}
                    id={`end-hour-button-${index}`}
                    data-cy={`end-hour-button-${index}`}
                    onClick={() => onEndTimeSelect(hour, index)}
                  >
                    <div className="label body10">{hour?.label}</div>
                  </div>
                );
              })}
            {outHoursEndTime && (
              <div className="body10">
                <MaskedInput
                  id="appt"
                  name="appt"
                  mask={TIMEMASK}
                  onChange={setOutHoursTimeEnd}
                />
              </div>
            )}
          </div>
          <div className="out-of-hours">
            <div className="body10">After hours ? (5PM to 8AM)</div>
            <input
              type="checkbox"
              id="outHoursCheckEndTime"
              onClick={setOutOfHoursCheckBox}
            />
          </div>
        </div>
      </ScrollView>
    </DateTimeStyle>
  );
};
